import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'ConditionDocumentalCampaign/GetDocumentTypes', method: 'GET', body: null, token: token })
}
